module.exports = __webpack_public_path__ + "static/media/rider1.456bfbf0.webp";